import { useState } from 'react';
import { type UseDeleteHookResult } from '@saviynt/biz-entity-catalog';

import { deleteClient } from '../data-sources';

/**
 * BizEntityCatalog delete hook adapter for client credentials.
 */
export function useClientDelete(): UseDeleteHookResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const mutate = async (id: string | number): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      await deleteClient(String(id));
    } catch (err) {
      const typedError = err instanceof Error ? err : new Error(String(err));

      setError(typedError);
      throw typedError;
    } finally {
      setIsLoading(false);
    }
  };

  return { mutate, isLoading, error };
}
